import { Stack } from '@mui/material';
import { useRouteMatch } from 'react-router-dom';
import { useStateParam } from 'features/Connect/features/Context/ConnectStateCodeContextProvider';
import { SignupButton } from '../../NavBarButtons/SignupButton';
import { LoginButton } from '../../NavBarButtons/LoginButton';
import { SupportButton } from '../../NavBarButtons/SupportButton';

export const CandidateNavBarUnauthenticatedView: React.FC = () => {
  const jobBoardState = useStateParam();
  const isConnectLogin = useRouteMatch({ path: '/connect/login', exact: true });
  const isConnectSignup = useRouteMatch({ path: '/connect/signup', exact: true });

  return (
    <Stack direction={'row'} gap={1}>
      {!isConnectSignup && <SignupButton jobBoardState={jobBoardState} />}
      {!isConnectLogin && <LoginButton jobBoardState={jobBoardState} />}
      <SupportButton />
    </Stack>
  );
};
